import React, { useEffect } from "react";
import { CellContext } from "@tanstack/react-table";

import { FormFiltersBackground, PageMain } from "components/molecules";
import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { CourseGroupFinancialReportRow, reportsApi } from "api/reportsApi";
import { PaziaDateSelect } from "components/atoms";
import { TanTableClient, useFilters, TanTableColumn } from "components/molecules";
import { toMoneyFormat } from "utils";
import { PaziaBreadcrumbs } from "components/atoms";
import { routes } from "consts";

export const CourseGroupsFinancialReport = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: QUERIES_KEYS.REPORTS.COURSES_GROUP_FINANCIAL(),
    queryFn: () => reportsApi.getCourseGroupsFinancialReport(filter),
  });

  const { filter, changeFilter } = useFilters();
  const columns: TanTableColumn<CourseGroupFinancialReportRow>[] = [
    {
      id: "courseGroupName",
      accessorKey: "courseGroupName",
      header: "Grupa kursów",
      size: 500,
    },
    {
      id: "totalIncome",
      accessorKey: "totalIncome",
      header: "Przychód",
      cell: (info) => <MoneyCell info={info} />,
    },
    {
      id: "totalExpense",
      accessorKey: "totalExpense",
      header: "Koszty",
      cell: (info) => <MoneyCell info={info} />,
    },
    {
      id: "netIncome",
      accessorKey: "netIncome",
      header: "Zysk",
      cell: (info) => <MoneyCell info={info} />,
    },
  ];

  useEffect(() => {
    refetch();
  }, [filter]);

  const onFromDateChange = (date: Date | null) =>
    changeFilter("from", date ? `createdDate ge ${date.toISOString()}` : "");

  const onToDateChange = (date: Date | null) => changeFilter("to", date ? `createdDate le ${date.toISOString()}` : "");
  const tableData = data?.data ?? [];
  return (
    <PageMain>
      <PaziaBreadcrumbs
        segments={[{ title: "Raporty", path: routes.REPORTS }, { title: "Zestawienie finansowe grup kursów" }]}
      />
      <FormFiltersBackground>
        <div className="flex flex-wrap items-center gap-2">
          <PaziaDateSelect name="dateFrom" label="Data od" onChange={onFromDateChange} />
          <PaziaDateSelect name="dateTo" label="Data od" onChange={onToDateChange} />
        </div>
      </FormFiltersBackground>
      <div className="mt-4">
        <TanTableClient data={tableData} columns={columns} />
      </div>
    </PageMain>
  );
};

const MoneyCell = ({ info }: { info: CellContext<CourseGroupFinancialReportRow, unknown> }) => {
  const value = info.getValue<number>();
  const valueClassname = value < 0 ? "text-red-500" : "text-green-500";
  return <span className={valueClassname}>{toMoneyFormat(info.getValue<number>(), true)}</span>;
};
